import { AddOnDiscount, AddOnDiscountFormData, Discount, DiscountFormData } from "../types/discount";
import { get, post } from "./fetch.core";

function sanitizeDiscountData(data: DiscountFormData) {
  const sanitized = { ...data } as any;

  const kind = sanitized.scheduleDiscountKind === "buyXGetY%Off" ? "buyXGetY%Off" : "simple";
  sanitized.scheduleDiscountKind = kind;
  if (kind === "simple") {
    delete sanitized.buyXGetYPercentOff;
  } else if (sanitized.buyXGetYPercentOff) {
    const bx = sanitized.buyXGetYPercentOff as Record<string, unknown>;
    const mx = bx.maxDiscountedUnits;
    if (mx === "" || mx === null || mx === undefined || Number.isNaN(Number(mx))) {
      delete bx.maxDiscountedUnits;
    } else {
      bx.maxDiscountedUnits = Number(mx);
    }
  }

  if (!sanitized.productRestriction?.type || sanitized.productRestriction.type === "none") {
    delete sanitized.productRestriction;
  } else {
    sanitized.productRestriction = {
      type: sanitized.productRestriction.type,
      restrictToIds: sanitized.productRestriction.restrictToIds || [],
    };
  }

  if (!sanitized.categoryRestriction?.type || sanitized.categoryRestriction.type === "none") {
    delete sanitized.categoryRestriction;
  } else {
    sanitized.categoryRestriction = {
      type: sanitized.categoryRestriction.type,
      restrictToIds: sanitized.categoryRestriction.restrictToIds || [],
    };
  }

  if (!sanitized.shipOptionRestriction?.type || sanitized.shipOptionRestriction.type === "none") {
    delete sanitized.shipOptionRestriction;
  } else {
    sanitized.shipOptionRestriction = {
      type: sanitized.shipOptionRestriction.type,
      restrictToIds: sanitized.shipOptionRestriction.restrictToIds || [],
    };
  }

  return sanitized;
}

async function createDiscount(data: DiscountFormData) {
  const sanitized = sanitizeDiscountData(data);
  await post("/admin/scheduleDiscount/create", sanitized);
}

export async function loadDiscounts() {
  const rst = await get<Discount[]>("/admin/scheduleDiscount/list");
  return rst.data;
}

async function editDiscount(data: DiscountFormData, id: string) {
  const sanitized = sanitizeDiscountData(data);
  await post(`/admin/scheduleDiscount/edit?discountId=${id}`, sanitized);
}

async function getDiscount(id: string) {
  const rst = await get<Discount>(`/admin/scheduleDiscount/get?discountId=${id}`);
  return rst.data;
}

async function createAddOnDiscount(data: AddOnDiscountFormData) {
  await post("/admin/addOnDiscount/create", data);
}

export async function loadAddOnOffers() {
  const rst = await get<AddOnDiscount[]>("/admin/addOnDiscount/list");
  return rst.data;
}

async function editAddOnDiscount(data: AddOnDiscountFormData, id: string) {
  await post(`/admin/addOnDiscount/edit?groupId=${id}`, data);
}

async function getAddOnDiscount(id: string) {
  const rst = await get<AddOnDiscount>(`/admin/addOnDiscount/get?groupId=${id}`);
  return rst.data;
}

const obj = {
  createDiscount,
  loadDiscounts,
  getDiscount,
  editDiscount,
  createAddOnDiscount,
  loadAddOnOffers,
  getAddOnDiscount,
  editAddOnDiscount,
};

export default obj;
